"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeisureSearchRequestBodySchema = void 0;
var zod_1 = require("zod");
/**
 * 국내 레저 PLP/SRP 상품 리스트 조회 requestBody
 * @see {@link https://yanolja.atlassian.net/wiki/spaces/~jusong.lee/pages/491947083/PLP+SRP#FE-API-Request---%EA%B5%AD%EB%82%B4%EB%A0%88%EC%A0%80-PLP%2FSRP-%EC%83%81%ED%92%88-%EB%A6%AC%EC%8A%A4%ED%8A%B8-%EC%A1%B0%ED%9A%8C}
 * */
exports.LeisureSearchRequestBodySchema = zod_1.z.object({
    pageName: zod_1.z.union([zod_1.z.literal('KEYWORD'), zod_1.z.literal('CATEGORY')]),
    page: zod_1.z.number().nullish(),
    searchType: zod_1.z.string().nullish(),
    sort: zod_1.z.string().nullish(),
    filters: zod_1.z.array(zod_1.z.record(zod_1.z.string(), zod_1.z.any())).nullish(),
    largeCategory: zod_1.z.number().nullish(),
    mediumCategory: zod_1.z.number().nullish(),
    keyword: zod_1.z.string().nullish(), // pageName=KEYWORD (SRP)일 때 필수
});
